import * as React from 'react'
import {render} from 'react-dom'
import Slider from './components/slider/Slider'


export const renderSliderImageVideo = (el, slides, onlyDots) => {
    if (!el) {
        el = document.querySelector('.widget-slider-image-video')
    }
    if (el && slides.length > 0) {
        render(<Slider slides={slides} onlyDots={onlyDots} twoCol={true} />, el)
    }
};
